<p class="mb-2">{{ text() }}</p>
